import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { SharedData, UserService } from '../../services/user.service';

import { Office } from '../../models/office';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { OfficeDetailComponent } from '../office-detail/office-detail.component';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import { OfficeCreateComponent } from '../office-create/office-create.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-office',
    templateUrl: './office.component.html',
    styleUrls: ['./office.component.scss']
})
export class OfficeComponent implements OnInit, OnDestroy {

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    offices = [];
    displayedColumns: string[] = ['OfficeId', 'OfficeDescription', 'ProgramSponsorId', 'OfficeActive', 'CreatedDate', 'ModifiedBy', 'edit'];
    dataSource = new MatTableDataSource<Office>();
    dialogRef: MatDialogRef<OfficeDetailComponent>;
    searching = true;
    searchValue = '';
    isCustomUiChange: boolean = false;
    private sharedDataSubscription: Subscription;

    constructor(private userService: UserService, private dialog: MatDialog) {
        this.sharedDataSubscription = this.userService.sharedData$
            .subscribe((data: SharedData) => {
                this.isCustomUiChange = data.isCustomUiChange;
            });
    }

    ngOnInit(): void {
        // Custom filter for global search
        this.dataSource.filterPredicate = (data: any, filter: string) => {
            const searchTerm = filter.trim().toLowerCase();

            const dataStr = `
            ${data?.OfficeId ?? ''}
            ${data?.OfficeDescription ?? ''}
            ${data?.ProgramSponsor?.ProgramSponsorDescription ?? ''}
            ${data?.OfficeActive ? 'active' : 'inactive'}
            ${data?.CreatedDate ?? ''}
            ${data?.ModifiedBy ?? ''}
        `.toLowerCase();

            return dataStr.includes(searchTerm);
        };

        this.getOffices();
    }

    ngOnDestroy(): void {
        this.sharedDataSubscription?.unsubscribe();
    }

    applyFilter() {
        this.dataSource.filter = this.searchValue.trim().toLowerCase();
    }

    clearSearch() {
        this.searchValue = '';
        this.applyFilter();
    }

    ngAfterViewInit() {

    }

    private getOffices() {
        this.userService.getOffices().subscribe(data => {

            this.offices = data;
            this.dataSource.data = this.offices;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            this.searching = false;
        }, err => {
            console.log(err);
        });
    }

    addNewOffice() {
        let className = localStorage.getItem("themeName");
        const dialogCreate = this.dialog.open(OfficeCreateComponent, {
            panelClass: className,
            data: {
                isCustomUiChange: this.isCustomUiChange
            },
            disableClose: true
        });
        dialogCreate.afterClosed().subscribe(result => {
            this.getOffices();
        });
    }

    public handleClick(office: Office) {
        let className = localStorage.getItem("themeName");
        this.dialogRef = this.dialog.open(OfficeDetailComponent,
            {
                data: {
                    dataKey: office
                }, panelClass: className
            });

        this.dialogRef.afterClosed().subscribe(result => {
            this.getOffices();
        });
    }
}
